import { Injectable, signal, effect, inject, Renderer2, RendererFactory2 } from '@angular/core';
import { ColorMode } from '../Types/color-mode.type';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private rendererFactory = inject(RendererFactory2);
  private renderer: Renderer2;
  private readonly THEME_KEY = 'preferred_theme';

  public mode = signal<ColorMode>(this.resolveInitialMode());

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    effect(() => {
      this.applyThemeToDom(this.mode());
    });
  }

  public toggleMode(): void {
    const newMode = this.mode() === 'light' ? 'dark' : 'light';
    this.mode.set(newMode);
    localStorage.setItem(this.THEME_KEY, newMode);
  }

  private resolveInitialMode(): ColorMode {
    const stored = localStorage.getItem(this.THEME_KEY) as ColorMode | null;
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }

    return 'light';
  }

  private applyThemeToDom(mode: ColorMode): void {
    const previousMode = mode === 'light' ? 'dark-theme' : 'light-theme';
    const currentMode = `${mode}-theme`;

    this.renderer.removeClass(document.body, previousMode);
    this.renderer.addClass(document.body, currentMode);
  }
}
